import $ from 'cash-dom';
import prestashop from 'prestashop';

prestashop.checkout = prestashop.checkout || {};

prestashop.checkout.onCheckOrderableCartResponse = (resp, paymentObject) => {
  if (resp.errors === true) {
    prestashop.emit('orderConfirmationErrors', {
      resp,
      paymentObject,
    });
    return true;
  }
  return false;
};

class Payment {
  constructor() {
    this.confirmationSelector = prestashop.selectors.checkout.confirmationSelector;
    this.conditionsSelector = prestashop.selectors.checkout.conditionsSelector;
    this.conditionAlertSelector = prestashop.selectors.checkout.conditionAlertSelector;
    this.additionalInformatonSelector = prestashop.selectors.checkout.additionalInformatonSelector;
    this.optionsForm = prestashop.selectors.checkout.optionsForm;
    this.termsCheckboxSelector = prestashop.selectors.checkout.termsCheckboxSelector;

  }


  init() {
    // eslint-disable-next-line no-unused-vars
    prestashop.on('orderConfirmationErrors', ({resp, paymentObject}) => {
      if (resp.cartUrl !== '') {
        location.href = resp.cartUrl;
      }
    });
    console.log('Payment created');
    
    const body = document.body;

    // bind methods to preserve `this` (equivalent of $.proxy)
    const boundToggle = this.toggleOrderButton.bind(this);
    const boundConfirm = this.confirm.bind(this);

    body.addEventListener('change', (event) => {
      const target = event.target;

      if (
        target.matches(`${this.conditionsSelector} input[type="checkbox"]`) ||
        target.matches('input[name="payment-option"]')
      ) {
        boundToggle();
      }
    });

    body.addEventListener('click', (event) => {
      const target = event.target;

      if (target.matches(`${this.confirmationSelector} button`)) {
        boundConfirm(event);
      }
    });

    // call once on init
    this.toggleOrderButton();

    // call collapseOptions directly
    this.collapseOptions();
  }

  collapseOptions() {
    $(`${this.additionalInformatonSelector}, ${this.optionsForm}`).hide();
  }

  getSelectedOption() {
    return $('input[name="payment-option"]:checked').attr('id');
  }

  haveTermsBeenAccepted() {
    return $(this.termsCheckboxSelector).prop('checked');
  }

  hideConfirmation() {
    $(this.confirmationSelector).hide();
  }

  showConfirmation() {
    $(this.confirmationSelector).show();
  }

  toggleOrderButton() {
    let show = true;
    $(`${this.conditionsSelector} input[type="checkbox"]`).each((_, checkbox) => {
      if (!checkbox.checked) {
        show = false;
      }
    });

    prestashop.emit('termsUpdated', {
      isChecked: show,
    });

    this.collapseOptions();

    const selectedOption = this.getSelectedOption();

    if (!selectedOption) {
      show = false;
    }

    $(`#${selectedOption}-additional-information`).show();
    $(`#pay-with-${selectedOption}-form`).show();

    $(prestashop.selectors.checkout.paymentBinary).hide();

    if ($(`#${selectedOption}`).hasClass('binary')) {
      const paymentOption = this.getPaymentOptionSelector(selectedOption);
      this.hideConfirmation();
      $(paymentOption).show();

      document.querySelectorAll(`${paymentOption} button, ${paymentOption} input`).forEach((element) => {
        if (show) {
          element.removeAttribute('disabled');
        } else {
          element.setAttribute('disabled', !show);
        }
      });

      if (show) {
        $(paymentOption).removeClass('disabled');
      } else {
        $(paymentOption).addClass('disabled');
      }
    } else {
      this.showConfirmation();
      $(`${this.confirmationSelector} button`).toggleClass('disabled', !show);
    //   $(`${this.confirmationSelector} button`).attr('disabled', !show);

      if (show) {
        $(this.conditionAlertSelector).hide();
      } else {
        $(this.conditionAlertSelector).show();
      }
    }
  }

  getPaymentOptionSelector(option) {
    const moduleName = $(`#${option}`).data('module-name');

    return `.js-payment-${moduleName}`;
  }

  showNativeFormErrors() {
    $(`input[name=payment-option], ${this.termsCheckboxSelector}`).each(function () {
      this.reportValidity();
    });
  }

  async confirm() {
    const option = this.getSelectedOption();
    const termsAccepted = this.haveTermsBeenAccepted();

    if (option === undefined || termsAccepted === false) {
      this.showNativeFormErrors();
      return;
    }
    console.log('payment confirmed');
    $(`${this.confirmationSelector} button`).addClass('disabled');
    // $(`${this.confirmationSelector} button`).attr('disabled',1);
    // We ask cart controller, if everything in the cart is still orderable
    const resp = await $.post(window.prestashop.urls.pages.order, {
      ajax: 1,
      action: 'checkCartStillOrderable',
    });


    // We process the information and allow other modules to intercept this
    const isRedirected = prestashop.checkout.onCheckOrderableCartResponse(resp, this);

    // If there is a redirect, we deny the form submit below, to allow the redirect to complete
    if (isRedirected) return;

    $(`#pay-with-${option}-form form`).submit();
  }
}

export default function () {
  const payment = new Payment();
  payment.init();

  return payment;
}
